module.exports = __webpack_public_path__ + "static/media/sidenLogoDark.76a9b5c1.svg";